import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "popup-header" }
const _hoisted_2 = { class: "popup-header-main" }
const _hoisted_3 = { class: "popup-header-texts" }
const _hoisted_4 = { class: "popup-header-subtitle" }
const _hoisted_5 = { class: "popup-body" }
const _hoisted_6 = { class: "form-group-card" }
const _hoisted_7 = { class: "form-group-content" }
const _hoisted_8 = { class: "field" }
const _hoisted_9 = {
  key: 0,
  class: "form-group-card"
}
const _hoisted_10 = { class: "form-group-content" }
const _hoisted_11 = { class: "field" }
const _hoisted_12 = { class: "form-group-card" }
const _hoisted_13 = { class: "form-group-content" }
const _hoisted_14 = { class: "fg g3" }
const _hoisted_15 = { class: "field span2" }
const _hoisted_16 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_17 = { class: "field" }
const _hoisted_18 = { class: "field" }
const _hoisted_19 = { class: "field" }
const _hoisted_20 = { class: "field" }
const _hoisted_21 = { class: "field span3" }
const _hoisted_22 = {
  key: 0,
  class: "field span3 field-switch"
}
const _hoisted_23 = { class: "popup-body-modern" }
const _hoisted_24 = {
  class: "show-more-container",
  style: {"display":"flex","justify-content":"center","margin":"1px 0"}
}
const _hoisted_25 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_26 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_27 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_28 = { class: "form-footer footer-modern" }
const _hoisted_29 = {
  class: "footer-right",
  style: {"margin-top":"1px","text-align":"right"}
}
const _hoisted_30 = { class: "popup-body-modern" }
const _hoisted_31 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_32 = { class: "form-footer footer-fixed footer-modern" }
const _hoisted_33 = {
  class: "footer-right",
  style: {"margin-top":"10px","text-align":"right"}
}

import { ref, computed, watch, onMounted } from 'vue';
import DxPopup, { DxToolbarItem } from 'devextreme-vue/popup';
import DxSelectBox from 'devextreme-vue/select-box';
import DxDateBox from 'devextreme-vue/date-box';
import DxTextBox from 'devextreme-vue/text-box';
import DxButton from 'devextreme-vue/button';
import DxSwitch from 'devextreme-vue/switch';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import DxForm, { DxItem as DxFormItem } from 'devextreme-vue/form';
import { DxRequiredRule } from 'devextreme-vue/validator';
import DxDataGrid, {
    DxFilterRow,
    DxPaging,
    DxScrolling,
    DxSearchPanel,
    DxSelection,
    DxToolbar as DxGridToolbar,
    DxItem as DxGridToolbarItem,
} from 'devextreme-vue/data-grid';
import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import ProComenziService from '@/services/Comercial/ProComenzi';
import PAR_Parteneri from '@/services/PAR/PAR_Parteneri';
import JwtServices from '@/services/JwtServices';
import AnafService from '@/services/AnafService';
import { useAddPartener } from '@/composable/useAddPartener';

interface Category {
    TipComanda: number;
    Denumire: string;
    TipFurnizor?: boolean | null;
    ValutaID?: string | null;
    AreContract?: boolean | null;
}

interface Props {
    visible: boolean;
    tipComanda?: number | null;
    comandaId?: string;
}

const NOTA_LIVRARE_DIRECTA = 'Livrare directă de la furnizor.';


export default /*@__PURE__*/_defineComponent({
  __name: 'PopupAdaugareDetaliu',
  props: {
    visible: { type: Boolean },
    tipComanda: {},
    comandaId: {}
  },
  emits: ["update:visible", "saved"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const selectedTipComandaLocal = ref<number | null>(null);
const categoriesArray = ref<Category[]>([]);
const dsValute = ref<DataSource | null>(null);
const dsClienti = ref<DataSource | null>(null);
const dsAgenti = ref<DataSource | null>(null);
const dsContracte = ref<DataSource | null>(null);

const headerClientId = ref<string | null>(null);
const isPartenerDropDownOpened = ref(false);
const headerAgentId = ref<string | null>(null);
const headerDataComenzii = ref<Date>(new Date());
const headerValutaId = ref<string | null>(null);
const headerTermenLivrare = ref<Date | null>(null);
const headerObservatii = ref<string>('');
const headerContractId = ref<string | null>(null);
const headerLivrareDirectaFurnizor = ref(false);
const isSaving = ref(false);

function onToggleLivrareDirecta(e: any) {
    if (!e.event) return; // ignoră setările programatice (reset la deschiderea popup-ului)
    const current = (headerObservatii.value || '').trim();
    if (e.value) {
        if (!current.includes(NOTA_LIVRARE_DIRECTA)) {
            headerObservatii.value = current ? `${current} ${NOTA_LIVRARE_DIRECTA}` : NOTA_LIVRARE_DIRECTA;
        }
    } else {
        headerObservatii.value = current.replace(NOTA_LIVRARE_DIRECTA, '').replace(/\s{2,}/g, ' ').trim();
    }
}

// ── Adăugare partener nou (dropdown + popup "Adaugă Partener") ──
const { isSubmitting: isSubmittingPartner, idempotencyKey: partnerIdempotencyKey, resetIdempotencyKey: resetPartnerIdempotencyKey } = useAddPartener();

const isPartnerModalVisible = ref(false);
const showExtendedDetails = ref(false);
const dsParteneriFiscal = ref<ODataStore | null>(null);
const dsBanci = ref<DataSource | null>(null);
const dsGrupuri = ref<DataSource | null>(null);
const dsZona = ref<DataSource | null>(null);
const dsValutaPartener = ref<ODataStore | null>(null);
const valutaPartenerSelectat = ref<any[]>([]);
const sBanci = ref<string | null>(null);
const sGrupuri = ref<string | null>(null);
const sZona = ref<string | null>(null);
const sValutaPartener = ref<string | null>(null);

const newPartnerData = ref<Record<string, any>>({
    Nume: '', CUI: '', Cod: '', Fiscal: '', Numar: '', Strada: '', Localitate: '',
    JudetID: null, TaraID: null, ZonaID: null, Cont: '', Banca: '', Litigiu: null,
    Extern: null, Intern: null, Observatii: '', AdaosPret: null, faraScadenta: null,
    ValutaID: '0A61647E-7391-4087-BC01-8EB9C2CEDEDD', Director: '', Fax: '', Tel: '',
    Email: '', www: '', GrupID: null, CP: '', CStrada: '', CLocalitate: '', CJudetID: null,
    CTaraID: null, CCP: '', Bloc: '', CBloc: '', Numarstrada: '', Scarabloc: '',
    CNumarstrada: '', CScarabloc: '', Scadenta: null, AgentID: null, Angajat: null,
    Memo: '', CreditLimita: null, DirectorEconomic: '', PersoanaContact: '',
    AplicaTVAlaIncasare: null, CifraAfacere: null, NrAngajati: null, Activ: true,
    Client: true, Furnizor: true, Owner: '', CalculezPenalitati: null,
    ParRecomandareID: null, CapitalSocial: null, AngajatID: null, ExternUE: null,
    StructuraLegaturaID: null, PartenerMasterID: null, RegimSpecialTVA: null,
    AplicaTvaDefalcat: null, Et: '', Ap: '', Adresa: '', CEt: '', CAp: '', CAdresa: '',
    CalculezPenalitatiDeLa: null, Prefix: '', Sufix: '', Caen: '', PunctID: null, ParentID: null,
});

const isBankModalVisible = ref(false);
const dsValuteBanca = ref<DataSource | null>(null);
const sValute = ref<string | null>(null);
const newBankData = ref<Record<string, any>>({
    PartenerID: null, Cod: null, Nume: null, CodIBAN: null, CodBIC: null,
    Principala: null, CodSWIFT: null, ValutaID: '0A61647E-7391-4087-BC01-8EB9C2CEDEDD',
    Ordine: null, Activ: null, TextFC: null,
});

const cuiOptions = computed(() => ({
    placeholder: 'Introdu CUI',
    valueChangeEvent: 'keyup',
    onValueChanged: (e: any) => { newPartnerData.value.Cod = e.value; },
    buttons: [{
        name: 'searchAnaf',
        location: 'after',
        options: {
            icon: 'search', width: 26, height: 26, type: 'default',
            hint: 'Caută în ANAF',
            onClick: () => onSearchAnaf(),
        },
    }],
}));

const tipComandaDenumire = computed<string>(() => {
    if (selectedTipComandaLocal.value == null) return '';
    return categoriesArray.value.find(c => c.TipComanda === selectedTipComandaLocal.value)?.Denumire ?? '';
});

const partenerLabel = computed<string>(() => {
    if (selectedTipComandaLocal.value == null) return 'Partener';
    const cat = categoriesArray.value.find(c => c.TipComanda === selectedTipComandaLocal.value);
    return cat?.TipFurnizor === true ? 'Furnizor' : 'Client';
});

const areContractRequired = computed<boolean>(() => {
    if (selectedTipComandaLocal.value == null) return false;
    const cat = categoriesArray.value.find(c => c.TipComanda === selectedTipComandaLocal.value);
    return cat?.AreContract === true;
});

function initDataSources() {
    const token = localStorage.getItem('ERA_Jwt') ?? '';
    const hdr = (e: any) => { e.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }; };

    ProComenziService.getCategoriiPermise().then((resp: any) => {
        categoriesArray.value = (resp.data ?? []) as Category[];
    });
    dsContracte.value = new DataSource({
        store: new ODataStore({ url: AppSetting.API_Url_ComercialOdata + 'COM_Contracte', key: 'ID', keyType: 'Guid', version: 4, beforeSend: hdr }),
        select: ['ID', 'Numar', 'Denumire'],
        sort: [{ selector: 'Numar', desc: false }],
    });
    dsValute.value = new DataSource({
        store: new ODataStore({ url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr }),
        select: ['Id', 'Simbol'],
        sort: [{ selector: 'Simbol', desc: false }],
    });
    dsAgenti.value = new DataSource({
        store: new ODataStore({ url: AppSetting.API_Url_ComercialOdata + 'COM_Agenti', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr }),
        select: ['Id', 'Nume'],
        sort: [{ selector: 'Nume', desc: false }],
    });
}

function buildDsClienti(tipFurnizor: boolean | null | undefined) {
    const token = localStorage.getItem('ERA_Jwt') ?? '';
    const hdr = (e: any) => { e.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }; };
    const filtru = tipFurnizor === true ? ['Furnizor', '=', true] : ['Client', '=', true];
    dsClienti.value = new DataSource({
        store: new ODataStore({ url: AppSetting.API_Url_ComercialOdata + 'PAR_Parteneri', key: 'ID', keyType: 'Guid', version: 4, beforeSend: hdr }),
        select: ['ID', 'Nume', 'ValutaID'],
        filter: filtru,
        sort: [{ selector: 'Nume', desc: false }],
    });
}

function onPartenerRowClick(e: any) {
    if (!e.data) return;
    headerClientId.value = e.data.ID;
    if (e.data.ValutaID) headerValutaId.value = e.data.ValutaID;
    isPartenerDropDownOpened.value = false;
}

function initPartnerDataSources() {
    const token = localStorage.getItem('ERA_Jwt') ?? '';
    const hdr = (e: any) => { e.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }; };

    dsParteneriFiscal.value = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'PAR_ParteneriFiscal', key: 'ID', keyType: 'Guid', version: 4, beforeSend: hdr,
    });
    dsBanci.value = new DataSource({
        store: { type: 'odata', url: AppSetting.API_Url_ComercialOdata + 'PAR_BanciParteneri', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr },
        select: ['Id', 'Nume'],
    });
    dsGrupuri.value = new DataSource({
        store: { type: 'odata', url: AppSetting.API_Url_ComercialOdata + 'PAR_Grupuri', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr },
        select: ['Id', 'Nume', 'Cod'],
        sort: [{ selector: 'Cod', desc: false }],
    });
    dsZona.value = new DataSource({
        store: { type: 'odata', url: AppSetting.API_Url_ComercialOdata + 'ERP_Zone', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr },
        select: ['Id', 'Nume'],
    });
    dsValutaPartener.value = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr,
    });
    dsValuteBanca.value = new DataSource({
        store: { type: 'odata', url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute', key: 'Id', keyType: 'Guid', version: 4, beforeSend: hdr },
        select: ['Id', 'Simbol'],
    });
}

function onAddNewPartener() {
    newPartnerData.value = {
        ...newPartnerData.value,
        Nume: '', CUI: '', Cod: '', Fiscal: '', Owner: JwtServices.GetUsername(),
        TaraID: 'D31C3594-8D39-4355-9A13-FD699A1B7290',
        ValutaID: '0A61647E-7391-4087-BC01-8EB9C2CEDEDD',
        Client: true, Furnizor: true, Activ: true,
    };
    sBanci.value = null;
    sGrupuri.value = null;
    sZona.value = null;
    sValutaPartener.value = null;
    valutaPartenerSelectat.value = [];
    showExtendedDetails.value = false;
    resetPartnerIdempotencyKey();
    isPartnerModalVisible.value = true;
}

function onSaveNewPartner() {
    if (!newPartnerData.value.Nume || String(newPartnerData.value.Nume).trim() === '') {
        notify('Completați câmpul obligatoriu "Nume"!', 'error', 1000);
        return;
    }
    if (!newPartnerData.value.Fiscal) {
        notify('Completați câmpul obligatoriu "Tip Fiscal"!', 'error', 1000);
        return;
    }

    isSubmittingPartner.value = true;
    PAR_Parteneri.save(newPartnerData.value, partnerIdempotencyKey.value).then((response: any) => {
        isSubmittingPartner.value = false;
        isPartnerModalVisible.value = false;
        notify('Datele au fost salvate cu succes!', 'success', 1000);

        const newId = response.data?.ID || response.data?.Id;
        if (newId) {
            headerClientId.value = newId;
            if (response.data.ValutaID) headerValutaId.value = response.data.ValutaID;
        }
        dsClienti.value?.reload();
    }).catch((error: any) => {
        isSubmittingPartner.value = false;
        const status = error?.response?.status;
        const data = error?.response?.data;
        if (status === 409 && data?.code === 'CUI_EXISTS') {
            notify(data.message || 'Partenerul cu acest CUI există deja!', 'error', 2000);
            return;
        }
        notify('Eroare la salvarea partenerului.', 'error', 2000);
    });
}

function onBanciRowClick(e: any) {
    if (e.data) {
        sBanci.value = e.data.Id;
        newPartnerData.value.Banca = e.data.Nume;
        newBankData.value.PartenerId = e.data.Id;
    } else {
        sBanci.value = null;
        newPartnerData.value.Banca = '';
        newBankData.value.PartenerId = null;
    }
}

function onAddNewBank() {
    newBankData.value = {
        PartenerID: null, Cod: null, Nume: null, CodIBAN: null, CodBIC: null,
        Principala: null, CodSWIFT: null, ValutaID: '0A61647E-7391-4087-BC01-8EB9C2CEDEDD',
        Ordine: null, Activ: null, TextFC: null,
    };
    sValute.value = '0A61647E-7391-4087-BC01-8EB9C2CEDEDD';
    isBankModalVisible.value = true;
}

function onSaveNewBank() {
    if (!newBankData.value.Nume || String(newBankData.value.Nume).trim() === '') {
        notify('Completați câmpul obligatoriu "Nume"!', 'error', 1000);
        return;
    }

    const savedBankData = { ...newBankData.value };
    PAR_Parteneri.saveBank(newBankData.value).then((response: any) => {
        isBankModalVisible.value = false;
        notify('Datele au fost salvate cu succes!', 'success', 1000);

        const newId = response?.data?.ID || response?.data?.Id || response?.data?.id || response?.data;
        dsBanci.value?.reload().then(() => {
            if (newId) {
                sBanci.value = newId;
                newPartnerData.value.Banca = savedBankData.Nume;
            }
        });
    }).catch(() => {
        notify('Datele există deja sau a apărut o eroare!', 'error', 2000);
    });
}

function onGrupuriRowClick(e: any) {
    if (e.data) {
        sGrupuri.value = e.data.Id;
        newPartnerData.value.GrupID = e.data.Id;
    } else {
        sGrupuri.value = null;
    }
}

function onZonaRowClick(e: any) {
    if (e.data) {
        sZona.value = e.data.Id;
        newPartnerData.value.ZonaID = e.data.Id;
    } else {
        sZona.value = null;
    }
}

function onValutaPartenerSelectionChanged(e: any) {
    if (e.selectedRowKeys?.length > 0) {
        sValutaPartener.value = e.selectedRowKeys[0];
    } else {
        sValutaPartener.value = null;
    }
    newPartnerData.value.ValutaID = sValutaPartener.value;
}

function onValuteRowClick(e: any) {
    if (e.data) {
        sValute.value = e.data.Id;
        newBankData.value.ValutaID = e.data.Id;
    } else {
        sValute.value = null;
    }
}

function handleInternChange(e: any) {
    if (e.value) {
        newPartnerData.value.Extern = false;
        newPartnerData.value.ExternUE = false;
    }
}

function handleExternChange(e: any) {
    if (e.value) {
        newPartnerData.value.Intern = false;
        newPartnerData.value.ExternUE = false;
    }
}

function handleExternUEChange(e: any) {
    if (e.value) {
        newPartnerData.value.Intern = false;
        newPartnerData.value.Extern = false;
    }
}

async function onSearchAnaf() {
    const cuiRaw = newPartnerData.value.CUI;
    if (!cuiRaw) {
        notify('Te rog introdu un CUI valid', 'warning', 2000);
        return;
    }

    const cui = Number(String(cuiRaw).replace(/\D/g, ''));
    if (!cui) {
        notify('Te rog introdu un CUI valid', 'warning', 2000);
        return;
    }

    try {
        const anafResult = await AnafService.getCompanyDetails(cui);
        if (!anafResult) {
            notify('CUI-ul nu a fost găsit sau nu există date publice.', 'warning', 3000);
            return;
        }

        const dg = anafResult.date_generale;
        const ss = anafResult.adresa_sediu_social;
        const formaOrg = String(dg?.forma_organizare ?? '').toUpperCase().trim();
        const scpTVA = Boolean(anafResult?.inregistrare_scop_Tva?.scpTVA);

        let fiscal = null;
        if (formaOrg.includes('PERSOANA FIZICA')) {
            fiscal = 'F';
        } else if (formaOrg.includes('PERSOANA JURIDICA')) {
            fiscal = scpTVA ? 'P' : 'N';
        }
        if (fiscal) newPartnerData.value.Fiscal = fiscal;

        newPartnerData.value.CUI = String(dg.cui);
        newPartnerData.value.Nume = dg.denumire ?? newPartnerData.value.Nume;
        newPartnerData.value.Numar = dg.nrRegCom ?? newPartnerData.value.Numar;
        newPartnerData.value.Caen = dg.cod_CAEN ?? newPartnerData.value.Caen;
        newPartnerData.value.CAdresa = dg.adresa ?? newPartnerData.value.CAdresa;
        newPartnerData.value.Localitate = ss.sdenumire_Localitate ?? newPartnerData.value.Localitate;
        newPartnerData.value.Strada = ss.sdenumire_Strada ?? newPartnerData.value.Strada;
        newPartnerData.value.Numarstrada = ss.snumar_Strada ?? newPartnerData.value.Numarstrada;
        newPartnerData.value.CP = ss.scod_Postal ?? newPartnerData.value.CP;
        newPartnerData.value.Tel = dg.telefon ?? newPartnerData.value.Tel;

        if (dg.iban) newPartnerData.value.Cont = dg.iban;
        newPartnerData.value.AplicaTVAlaIncasare = anafResult.inregistrare_RTVAI?.statusTvaIncasare ?? false;

        const extras: string[] = [];
        if (dg.stare_inregistrare) extras.push(`Stare: ${dg.stare_inregistrare}`);
        if (typeof dg.statusRO_e_Factura === 'boolean') extras.push(`RO e-Factura: ${dg.statusRO_e_Factura ? 'DA' : 'NU'}`);

        try {
            let finData = await AnafService.getFinancialData(cui, 2024);
            if (!finData || !finData.i || finData.i.length === 0) {
                finData = await AnafService.getFinancialData(cui, 2023);
            }

            if (finData && finData.i) {
                const indicatori = finData.i;
                const caRow = indicatori.find((item: any) => {
                    const nume = item.val_den_indicator.toUpperCase();
                    return nume.includes('CIFRA DE AFACERI NET') || nume === 'VENITURI TOTALE';
                });
                const angRow = indicatori.find((item: any) => {
                    const nume = item.val_den_indicator.toUpperCase();
                    return nume.includes('NUMAR MEDIU DE SALARIATI') || nume.includes('NR. MEDIU SALARIATI');
                });

                if (caRow) {
                    newPartnerData.value.CifraAfacere = caRow.val_indicator;
                    extras.push(`CA: ${caRow.val_indicator.toLocaleString()}`);
                }
                if (angRow) {
                    newPartnerData.value.NrAngajati = angRow.val_indicator;
                    extras.push(`Angajați: ${angRow.val_indicator}`);
                }
            }
        } catch (finError) {
            console.warn('Datele financiare nu au putut fi încărcate.', finError);
        }

        if (extras.length) {
            const prev = newPartnerData.value.Memo ? String(newPartnerData.value.Memo).trim() + '\n' : '';
            newPartnerData.value.Memo = prev + extras.join(' | ');
        }

        notify('Datele au fost preluate cu succes!', 'success', 2000);
    } catch (error) {
        console.error(error);
        notify('Eroare la interogarea ANAF', 'error', 4000);
    }
}

async function loadCurrentAgent() {
    try {
        const res = await ProComenziService.getAgentCurent();
        headerAgentId.value = res.data?.AgentId ?? null;
    } catch {
        headerAgentId.value = null;
    }
}

async function handleSave() {
    isSaving.value = true;
    try {
        const resp = await ProComenziService.creeazaComanda({
            Tipcomanda: selectedTipComandaLocal.value,
            ClientId: headerClientId.value ?? null,
            AgentId: headerAgentId.value ?? null,
            DataComenzii: headerDataComenzii.value,
            ValutaId: headerValutaId.value ?? null,
            TermenLivrare: headerTermenLivrare.value ?? null,
            Observatii: headerObservatii.value || null,
            ContractId: headerContractId.value ?? null,
            LivrareDirectaFurnizor: partenerLabel.value === 'Client' ? headerLivrareDirectaFurnizor.value : false,
        });
        emit('saved', resp.data);
        emit('update:visible', false);
    } catch (err: any) {
        const raw = err?.response?.data;
        const msg = typeof raw === 'string' ? raw : (err?.message ?? 'Eroare la salvare.');
        notify(msg, 'error', 3000);
    } finally {
        isSaving.value = false;
    }
}

onMounted(() => {
    initDataSources();
    initPartnerDataSources();
});

watch(sValutaPartener, (newId) => {
    if (newId && dsValutaPartener.value) {
        (dsValutaPartener.value as ODataStore).byKey(newId).then((x: any) => {
            x.Simbol = x.Simbol ?? '(fara simbol)';
            valutaPartenerSelectat.value = [x];
        });
    } else {
        valutaPartenerSelectat.value = [];
    }
});

watch(selectedTipComandaLocal, (tipComanda) => {
    headerClientId.value = null;
    if (tipComanda == null) {
        dsClienti.value = null;
        headerValutaId.value = null;
        return;
    }
    const cat = categoriesArray.value.find(c => c.TipComanda === tipComanda);
    buildDsClienti(cat?.TipFurnizor);
    headerValutaId.value = cat?.ValutaID ?? null;
});

watch(() => props.visible, async (isVisible) => {
    if (isVisible) {
        selectedTipComandaLocal.value = props.tipComanda ?? null;
        headerClientId.value = null;
        headerDataComenzii.value = new Date();
        headerValutaId.value = null;
        headerTermenLivrare.value = null;
        headerObservatii.value = '';
        headerContractId.value = null;
        headerLivrareDirectaFurnizor.value = false;
        await loadCurrentAgent();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(DxPopup), {
      visible: __props.visible,
      "show-title": true,
      "drag-enabled": true,
      "resize-enabled": false,
      "show-close-button": false,
      "close-on-outside-click": false,
      width: 680,
      height: 'auto',
      onHidden: _cache[11] || (_cache[11] = ($event: any) => (emit('update:visible', false)))
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[23] || (_cache[23] = _createElementVNode("span", { class: "dx-icon dx-icon-add popup-header-icon" }, null, -1)),
            _createElementVNode("div", _hoisted_3, [
              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "popup-header-title" }, "Comandă nouă", -1)),
              _createElementVNode("div", _hoisted_4, _toDisplayString(tipComandaDenumire.value || 'Selectați tipul comenzii'), 1)
            ])
          ]),
          _createElementVNode("span", {
            class: "header-close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:visible', false)))
          }, "×")
        ])
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "form-group-caption" }, [
              _createTextVNode("Tip Comandă "),
              _createElementVNode("span", { class: "required-star" }, "*")
            ], -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_unref(DxSelectBox), {
                  value: selectedTipComandaLocal.value,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((selectedTipComandaLocal).value = $event)),
                  items: categoriesArray.value,
                  "display-expr": "Denumire",
                  "value-expr": "TipComanda",
                  "search-enabled": true,
                  "show-clear-button": true,
                  placeholder: "Selectați tipul comenzii..."
                }, null, 8, ["value", "items"])
              ])
            ])
          ]),
          (areContractRequired.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "form-group-caption" }, [
                  _createTextVNode("Contract "),
                  _createElementVNode("span", { class: "required-star" }, "*")
                ], -1)),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_unref(DxSelectBox), {
                      value: headerContractId.value,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((headerContractId).value = $event)),
                      "data-source": dsContracte.value,
                      "display-expr": "Numar",
                      "value-expr": "ID",
                      "search-enabled": true,
                      "show-clear-button": true,
                      placeholder: "Selectați contractul..."
                    }, null, 8, ["value", "data-source"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _cache[33] || (_cache[33] = _createElementVNode("div", { class: "form-group-caption" }, "Informații Comandă", -1)),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(partenerLabel.value) + " ", 1),
                    _cache[26] || (_cache[26] = _createElementVNode("span", { class: "required-star" }, "*", -1))
                  ]),
                  _createVNode(_unref(DxDropDownBox), {
                    value: headerClientId.value,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((headerClientId).value = $event)),
                    opened: isPartenerDropDownOpened.value,
                    "onUpdate:opened": _cache[4] || (_cache[4] = ($event: any) => ((isPartenerDropDownOpened).value = $event)),
                    "data-source": dsClienti.value,
                    "display-expr": "Nume",
                    "value-expr": "ID",
                    "show-clear-button": true,
                    disabled: selectedTipComandaLocal.value == null,
                    placeholder: partenerLabel.value ? 'Selectați ' + partenerLabel.value.toLowerCase() + '...' : 'Selectați tipul comenzii mai întâi...',
                    "content-template": "gridContent",
                    "drop-down-options": { width: 500, height: 400 }
                  }, {
                    gridContent: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_unref(DxDataGrid), {
                          "data-source": dsClienti.value,
                          columns: ['Nume'],
                          "hover-state-enabled": true,
                          height: 280,
                          "remote-operations": true,
                          onRowClick: onPartenerRowClick
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(DxScrolling), { mode: "virtual" }),
                            _createVNode(_unref(DxFilterRow), { visible: true }),
                            _createVNode(_unref(DxPaging), {
                              enabled: true,
                              "page-size": 5
                            }),
                            _createVNode(_unref(DxSearchPanel), {
                              visible: true,
                              placeholder: "Caută..."
                            }),
                            _createVNode(_unref(DxGridToolbar), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(DxGridToolbarItem), { location: "after" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(DxButton), {
                                      icon: "plus",
                                      type: "success",
                                      height: "25px",
                                      width: "25px",
                                      onClick: onAddNewPartener
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(DxGridToolbarItem), { name: "searchPanel" })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["data-source"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["value", "opened", "data-source", "disabled", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _cache[27] || (_cache[27] = _createElementVNode("label", null, [
                    _createTextVNode("Agent "),
                    _createElementVNode("span", { class: "required-star" }, "*")
                  ], -1)),
                  _createVNode(_unref(DxSelectBox), {
                    value: headerAgentId.value,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((headerAgentId).value = $event)),
                    "data-source": dsAgenti.value,
                    "display-expr": "Nume",
                    "value-expr": "Id",
                    "search-enabled": true,
                    "search-expr": "Nume",
                    "show-clear-button": true,
                    placeholder: "Selectați agentul..."
                  }, null, 8, ["value", "data-source"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _cache[28] || (_cache[28] = _createElementVNode("label", null, "Data Comenzii", -1)),
                  _createVNode(_unref(DxDateBox), {
                    value: headerDataComenzii.value,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((headerDataComenzii).value = $event)),
                    "display-format": "dd.MM.yyyy",
                    "show-clear-button": false
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _cache[29] || (_cache[29] = _createElementVNode("label", null, "Valută", -1)),
                  _createVNode(_unref(DxSelectBox), {
                    value: headerValutaId.value,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((headerValutaId).value = $event)),
                    "data-source": dsValute.value,
                    "display-expr": "Simbol",
                    "value-expr": "Id",
                    "show-clear-button": true,
                    placeholder: "Selectați valuta..."
                  }, null, 8, ["value", "data-source"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _cache[30] || (_cache[30] = _createElementVNode("label", null, "Termen Livrare", -1)),
                  _createVNode(_unref(DxDateBox), {
                    value: headerTermenLivrare.value,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((headerTermenLivrare).value = $event)),
                    "display-format": "dd.MM.yyyy",
                    "show-clear-button": true
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[31] || (_cache[31] = _createElementVNode("label", null, "Observații", -1)),
                  _createVNode(_unref(DxTextBox), {
                    value: headerObservatii.value,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((headerObservatii).value = $event)),
                    "show-clear-button": true,
                    placeholder: "Observații comandă..."
                  }, null, 8, ["value"])
                ]),
                (partenerLabel.value === 'Client')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createVNode(_unref(DxSwitch), {
                        value: headerLivrareDirectaFurnizor.value,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((headerLivrareDirectaFurnizor).value = $event)),
                        onValueChanged: onToggleLivrareDirecta
                      }, null, 8, ["value"]),
                      _cache[32] || (_cache[32] = _createElementVNode("label", { class: "switch-label" }, [
                        _createTextVNode(" Livrare directă de la furnizor "),
                        _createElementVNode("span", { class: "switch-hint" }, "Furnizorul livrează marfa direct la client, fără să treacă prin gestiunea proprie — comanda poate fi pusă în lucru și facturată fără rezervare de stoc.")
                      ], -1))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: { text: isSaving.value ? 'Se salvează...' : 'Salvează și deschide', type: 'default', disabled: isSaving.value || selectedTipComandaLocal.value == null || !headerClientId.value || !headerAgentId.value || (areContractRequired.value && !headerContractId.value), onClick: handleSave }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: { text: 'Anulează', stylingMode: 'outlined', onClick: () => emit('update:visible', false) }
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(DxPopup), {
      visible: isPartnerModalVisible.value,
      width: 1450,
      height: 684,
      "show-title": true,
      title: "Adăugare Partener Nou",
      onHiding: _cache[18] || (_cache[18] = ($event: any) => (isPartnerModalVisible.value = false))
    }, {
      title: _withCtx(() => [...(_cache[34] || (_cache[34] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-add" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare partener"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează detaliile partenerului ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nou ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_unref(DxForm), {
            "form-data": newPartnerData.value,
            "col-count": 3,
            "col-span": 3
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DxFormItem), {
                "item-type": "group",
                caption: "Identitate & Fiscal",
                "col-count": 6,
                "css-class": "form-section-simple form-section-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CUI",
                    label: { text: 'CUI/CNP' },
                    "editor-options": cuiOptions.value,
                    "col-span": 3
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DxRequiredRule), { message: "Câmpul 'CUI/CNP' este obligatoriu" })
                    ]),
                    _: 1
                  }, 8, ["editor-options"]),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Nume",
                    "col-span": 3
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DxRequiredRule), { message: "Câmpul 'Nume' este obligatoriu" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Fiscal",
                    "editor-type": "dxSelectBox",
                    "col-span": 4,
                    label: { text: 'Tip Fiscal' },
                    "editor-options": {
                            dataSource: dsParteneriFiscal.value,
                            displayExpr: 'Nume',
                            valueExpr: 'Cod',
                            placeholder: 'Selectează Tip Fiscal',
                            searchEnabled: true,
                        }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DxRequiredRule), { message: "Câmpul 'Tip Fiscal' este obligatoriu" })
                    ]),
                    _: 1
                  }, 8, ["editor-options"]),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Numar",
                    label: { text: 'Regim Comerț' },
                    "col-span": 2
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Caen",
                    label: { text: 'Cod CAEN' },
                    "col-span": 2
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Owner",
                    "editor-options": { readOnly: true },
                    label: { text: 'Responsabil' },
                    "col-span": 2
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Cont",
                    label: { text: 'IBAN' },
                    "col-span": 2
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Memo",
                    "col-span": 6,
                    "editor-options": { height: 80 },
                    "editor-type": "dxTextArea"
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(DxFormItem), {
                "item-type": "group",
                caption: "Sediu Social",
                "col-span": 1,
                "col-count": 4,
                "css-class": "form-section-simple form-section-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Strada",
                    "col-span": 3
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Numarstrada",
                    "col-span": 1,
                    label: { text: 'Nr.' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Bloc",
                    "col-span": 1
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Scarabloc",
                    "col-span": 1,
                    label: { text: 'Sc.' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Et",
                    "col-span": 1,
                    label: { text: 'Etaj' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Ap",
                    "col-span": 1,
                    label: { text: 'Ap.' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Localitate",
                    "col-span": 3
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CP",
                    "col-span": 1,
                    label: { text: 'C.P.' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Adresa",
                    "col-span": 4,
                    "editor-type": "dxTextArea",
                    "editor-options": { height: 80 },
                    label: { text: 'Adresă Completă' }
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(DxFormItem), {
                "item-type": "group",
                caption: "Domiciliu Fiscal",
                "col-span": 1,
                "col-count": 4,
                "css-class": "form-section-simple form-section-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CStrada",
                    "col-span": 3,
                    label: { text: 'Strada' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CNumarstrada",
                    "col-span": 1,
                    label: { text: 'Nr.' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CBloc",
                    "col-span": 1,
                    label: { text: 'Bl.' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CScarabloc",
                    "col-span": 1,
                    label: { text: 'Sc.' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CEt",
                    "col-span": 1,
                    label: { text: 'Etaj' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CAp",
                    "col-span": 1,
                    label: { text: 'Ap.' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CLocalitate",
                    "col-span": 3,
                    label: { text: 'Localitate' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CCP",
                    "col-span": 1,
                    label: { text: 'C.P.' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CAdresa",
                    "col-span": 4,
                    "editor-type": "dxTextArea",
                    "editor-options": { height: 80 },
                    label: { text: 'Adresă Completă' }
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(DxFormItem), {
                "col-count": 3,
                "col-span": 3
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_unref(DxButton), {
                      "element-attr": { class: 'show-more-btn' },
                      text: showExtendedDetails.value ? 'Ascunde detalii suplimentare' : 'Completează detalii suplimentare',
                      icon: showExtendedDetails.value ? 'chevronup' : 'chevrondown',
                      type: "normal",
                      "styling-mode": "text",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (showExtendedDetails.value = !showExtendedDetails.value))
                    }, null, 8, ["text", "icon"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(DxFormItem), {
                "item-type": "group",
                caption: "Configurare Financiară & Comericală",
                visible: showExtendedDetails.value,
                "col-count": 2
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DxFormItem), { label: { text: 'Bancă (Internă)' } }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DxDropDownBox), {
                        value: sBanci.value,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((sBanci).value = $event)),
                        "data-source": dsBanci.value,
                        "display-expr": "Nume",
                        "value-expr": "Id",
                        "show-clear-button": true,
                        placeholder: "Selectează bancă",
                        "content-template": "gridContent",
                        "drop-down-options": { width: 200 }
                      }, {
                        gridContent: _withCtx(() => [
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_unref(DxDataGrid), {
                              "data-source": dsBanci.value,
                              columns: ['Nume'],
                              "hover-state-enabled": true,
                              height: 280,
                              "remote-operations": true,
                              onRowClick: onBanciRowClick
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(DxPaging), {
                                  enabled: true,
                                  "page-size": 5
                                }),
                                _createVNode(_unref(DxFilterRow), { visible: true }),
                                _createVNode(_unref(DxScrolling), { mode: "virtual" }),
                                _createVNode(_unref(DxGridToolbar), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(DxGridToolbarItem), { location: "after" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(DxButton), {
                                          icon: "plus",
                                          type: "success",
                                          height: "25px",
                                          width: "25px",
                                          onClick: onAddNewBank
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_unref(DxGridToolbarItem), { name: "searchPanel" })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["data-source"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["value", "data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(DxFormItem), { label: { text: 'Valută' } }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DxDropDownBox), {
                        value: sValutaPartener.value,
                        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((sValutaPartener).value = $event)),
                        "data-source": valutaPartenerSelectat.value,
                        "show-clear-button": true,
                        "display-expr": "Simbol",
                        "value-expr": "Id",
                        placeholder: "RON"
                      }, {
                        content: _withCtx(() => [
                          _createVNode(_unref(DxDataGrid), {
                            "data-source": dsValutaPartener.value,
                            "selected-row-keys": sValutaPartener.value ? [sValutaPartener.value] : [],
                            columns: ['Simbol'],
                            "hover-state-enabled": true,
                            height: "100%",
                            onSelectionChanged: onValutaPartenerSelectionChanged
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(DxSelection), { mode: "single" }),
                              _createVNode(_unref(DxPaging), {
                                enabled: true,
                                "page-size": 5
                              }),
                              _createVNode(_unref(DxFilterRow), { visible: true }),
                              _createVNode(_unref(DxSearchPanel), {
                                visible: true,
                                placeholder: "Caută..."
                              })
                            ]),
                            _: 1
                          }, 8, ["data-source", "selected-row-keys"])
                        ]),
                        _: 1
                      }, 8, ["value", "data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(DxFormItem), { "data-field": "CapitalSocial" }),
                  _createVNode(_unref(DxFormItem), { "data-field": "CifraAfacere" }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "NrAngajati",
                    label: { text: 'Nr. Angajati' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    label: { text: 'Grup' },
                    "col-span": 1
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DxDropDownBox), {
                        value: sGrupuri.value,
                        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((sGrupuri).value = $event)),
                        "data-source": dsGrupuri.value,
                        "display-expr": "Nume",
                        "value-expr": "Id",
                        "show-clear-button": true,
                        placeholder: "Selectează ",
                        "content-template": "gridContent",
                        "drop-down-options": { width: 400 }
                      }, {
                        gridContent: _withCtx(() => [
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_unref(DxDataGrid), {
                              "data-source": dsGrupuri.value,
                              columns: ['Nume'],
                              "hover-state-enabled": true,
                              height: 280,
                              "remote-operations": true,
                              onRowClick: onGrupuriRowClick
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(DxPaging), {
                                  enabled: true,
                                  "page-size": 5
                                }),
                                _createVNode(_unref(DxFilterRow), { visible: true }),
                                _createVNode(_unref(DxScrolling), { mode: "virtual" })
                              ]),
                              _: 1
                            }, 8, ["data-source"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["value", "data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(DxFormItem), {
                    label: { text: 'Zona' },
                    "col-span": 1
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DxDropDownBox), {
                        value: sZona.value,
                        "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((sZona).value = $event)),
                        "data-source": dsZona.value,
                        "display-expr": "Nume",
                        "value-expr": "Id",
                        "show-clear-button": true,
                        placeholder: "Selectează ",
                        "content-template": "gridContent",
                        "drop-down-options": { width: 200 }
                      }, {
                        gridContent: _withCtx(() => [
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(_unref(DxDataGrid), {
                              "data-source": dsZona.value,
                              columns: ['Nume'],
                              "hover-state-enabled": true,
                              height: 280,
                              "remote-operations": true,
                              onRowClick: onZonaRowClick
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(DxPaging), {
                                  enabled: true,
                                  "page-size": 5
                                }),
                                _createVNode(_unref(DxFilterRow), { visible: true }),
                                _createVNode(_unref(DxScrolling), { mode: "virtual" })
                              ]),
                              _: 1
                            }, 8, ["data-source"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["value", "data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "AdaosPret",
                    "col-span": 1
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Scadenta",
                    "col-span": 1
                  })
                ]),
                _: 1
              }, 8, ["visible"]),
              _createVNode(_unref(DxFormItem), {
                "item-type": "group",
                caption: "Contacte & Diverse",
                visible: showExtendedDetails.value,
                "col-count": 2
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Tel",
                    label: { text: 'Telefon' }
                  }),
                  _createVNode(_unref(DxFormItem), { "data-field": "Fax" }),
                  _createVNode(_unref(DxFormItem), { "data-field": "Email" }),
                  _createVNode(_unref(DxFormItem), { "data-field": "Director" }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Observatii",
                    "col-span": 2,
                    "editor-options": { height: 100 },
                    "editor-type": "dxTextArea"
                  })
                ]),
                _: 1
              }, 8, ["visible"]),
              _createVNode(_unref(DxFormItem), {
                "item-type": "group",
                caption: "System Flags",
                visible: showExtendedDetails.value,
                "col-count": 2,
                "col-span": 2
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "AplicaTVAlaIncasare",
                    "editor-type": "dxCheckBox",
                    label: { text: 'TVA la Încasare' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "RegimSpecialTVA",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Intern",
                    "editor-type": "dxCheckBox",
                    "editor-options": { onValueChanged: handleInternChange }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Extern",
                    "editor-type": "dxCheckBox",
                    label: { text: 'Extern Non UE' },
                    "editor-options": { onValueChanged: handleExternChange }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "ExternUE",
                    "editor-type": "dxCheckBox",
                    label: { text: 'Extern UE' },
                    "editor-options": { onValueChanged: handleExternUEChange }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Client",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Furnizor",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Activ",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "AplicaTvaDefalcat",
                    "editor-type": "dxCheckBox",
                    label: { text: 'Split TVA' }
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "faraScadenta",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "CalculezPenalitati",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_unref(DxFormItem), {
                    "data-field": "Litigiu",
                    "editor-type": "dxCheckBox"
                  })
                ]),
                _: 1
              }, 8, ["visible"])
            ]),
            _: 1
          }, 8, ["form-data"]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_unref(DxButton), {
                text: "Salvează Compania",
                type: "success",
                onClick: onSaveNewPartner,
                height: "32px",
                width: "200px",
                "styling-mode": "outlined",
                disabled: _unref(isSubmittingPartner)
              }, null, 8, ["disabled"]),
              _createVNode(_unref(DxButton), {
                text: "Închide",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (isPartnerModalVisible.value = false)),
                height: "32px",
                width: "200px",
                "styling-mode": "outlined"
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(DxPopup), {
      visible: isBankModalVisible.value,
      width: 800,
      height: 550,
      "show-title": true,
      title: "Adăugare Bancă",
      onHiding: _cache[21] || (_cache[21] = ($event: any) => (isBankModalVisible.value = false))
    }, {
      title: _withCtx(() => [...(_cache[35] || (_cache[35] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-add" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare bancă"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează detaliile băncii ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nou ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_unref(DxForm), {
            "form-data": newBankData.value,
            "col-count": 2,
            "col-span": 2
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(DxFormItem), { "data-field": "Ordine" }),
              _createVNode(_unref(DxFormItem), { "data-field": "Cod" }),
              _createVNode(_unref(DxFormItem), { "data-field": "Nume" }),
              _createVNode(_unref(DxFormItem), { label: { text: 'Valută' } }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DxDropDownBox), {
                    value: sValute.value,
                    "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((sValute).value = $event)),
                    "data-source": dsValuteBanca.value,
                    "display-expr": "Simbol",
                    "value-expr": "Id",
                    "show-clear-button": true,
                    placeholder: "RON",
                    "content-template": "gridContent"
                  }, {
                    gridContent: _withCtx(() => [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_unref(DxDataGrid), {
                          "data-source": dsValuteBanca.value,
                          columns: ['Simbol'],
                          "hover-state-enabled": true,
                          height: 280,
                          "remote-operations": true,
                          onRowClick: onValuteRowClick
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(DxPaging), {
                              enabled: true,
                              "page-size": 5
                            }),
                            _createVNode(_unref(DxFilterRow), { visible: true }),
                            _createVNode(_unref(DxScrolling), { mode: "virtual" })
                          ]),
                          _: 1
                        }, 8, ["data-source"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["value", "data-source"])
                ]),
                _: 1
              }),
              _createVNode(_unref(DxFormItem), { "data-field": "CodIBAN" }),
              _createVNode(_unref(DxFormItem), { "data-field": "CodBIC" }),
              _createVNode(_unref(DxFormItem), { "data-field": "CodSWIFT" }),
              _createVNode(_unref(DxFormItem), { "data-field": "TextFC" }),
              _createVNode(_unref(DxFormItem), {
                "data-field": "Principala",
                "editor-type": "dxCheckBox"
              }),
              _createVNode(_unref(DxFormItem), {
                "data-field": "Activ",
                "editor-type": "dxCheckBox"
              })
            ]),
            _: 1
          }, 8, ["form-data"]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_unref(DxButton), {
                text: "Salvează Banca",
                type: "success",
                onClick: onSaveNewBank,
                height: "32px",
                width: "200px",
                "styling-mode": "outlined"
              }),
              _createVNode(_unref(DxButton), {
                text: "Închide",
                onClick: _cache[20] || (_cache[20] = ($event: any) => (isBankModalVisible.value = false)),
                height: "32px",
                width: "200px",
                "styling-mode": "outlined"
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})